import { SelectDataType } from "@sso/components/Form";
import { UserRole } from "@sso/constant";

export enum SortKeys {
  ASC = "ASC",
  DESC = "DESC",
  NONE = "NONE",
}

export enum SearchFieldKeys {
  TEXT = "text",
  SELECT = "select",
  DATE_RANGE = "dateRange",
}

export enum SearchParameterKeys {
  CONTAIN = "cn",
  EQUAL = "eq",

  /** Less than or equal */
  LESS_THAN_OR_EQUAL = "le",

  /** Greater than or equal */
  GREATER_THAN_OR_EQUAL = "ge",

  /** There is no direct translation between 'between' and the api, at the final stage we should map it the 'le' and 'ge' */
  BETWEEN = "between",
}

export type ID = string | number;

export type SearchType =
  | { type: SearchFieldKeys.TEXT; searchParamaterKey?: SearchParameterKeys; nullable?: boolean; field?: string }
  | {
      type: SearchFieldKeys.SELECT;
      options: SelectDataType[];
      searchParamaterKey?: SearchParameterKeys;
      nullable?: boolean;
      field?: string;
    }
  | {
      type: SearchFieldKeys.DATE_RANGE;
      startDate?: Date;
      endDate?: Date;
      field?: string;
    };

export interface SortColumn {
  column: string;
  type: SortKeys;
  multiField?: string[];
}

/**
 * Represents a search column with a single `value` field
 * for search parameters other than `BETWEEN`.
 */
export interface SingleValueSearchColumn {
  column: string;
  /** The search value for standard parameters */
  value: string;
  title: string;
  parameter?: Exclude<SearchParameterKeys, SearchParameterKeys.BETWEEN>;
  nullable?: boolean;
}

/**
 * Represents a search column with `startValue` and `endValue`
 * fields specifically for the `BETWEEN` search parameter.
 */
export interface BetweenValueSearchColumn {
  column: string;
  /** The start value for `BETWEEN` searches */
  startValue?: string;
  /** The end value for `BETWEEN` searches */
  endValue?: string;
  title: string;
  parameter: SearchParameterKeys.BETWEEN;
}

export type SearchColumn = SingleValueSearchColumn | BetweenValueSearchColumn;

export type SearchObject = Record<string, SearchColumn>;

export interface TablePagination {
  pageSize: number;
  totalItems: number;
  totalPages: number;
  pageIndex: number;
  sort: SortColumn;
  search: SearchObject;
}

export interface TableColumn<T = unknown> {
  name: string;
  field: T;
  actionField?: string;
  sortable?: boolean;
  search?: SearchType;
  access?: UserRole[];
  dataField?: T;
  multiField?: string[];
}

export interface TableHeaderActionButton {
  text: string;
  handleClick(): void;
}
